var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { makeStyles as _makeStyles } from '@material-ui/styles';
import { defaultTheme } from "./defaultTheme";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var generateId = function (rule, style) {
    return (style === null || style === void 0 ? void 0 : style.options.classNamePrefix) + "-" + rule.key;
};
export function makeStyles(style, options) {
    return _makeStyles(style, __assign(__assign({}, options), { 
        // @ts-ignore
        defaultTheme: defaultTheme, generateClassName: generateId }));
}
export function makeStylesWithDefaultGenerateClassName(style, options) {
    return _makeStyles(style, __assign(__assign({}, options), { 
        // @ts-ignore
        defaultTheme: defaultTheme }));
}
